import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import { removePartnerTokens } from '@/api/utilities';
import { useRouter } from '@/hooks/router.hooks';

export const UnauthorizedScreen = () => {
  const { generateAuthLink } = useRouter();
  useEffect(() => {
    removePartnerTokens();
  }, []);

  return <Navigate to={generateAuthLink()} />;
};
